<div #popup class="no-select mat-dialog-edition-form mat-dialog " appDraggable>
  <!-- HEADER -->
  <div class="popup-header d-flex justify-content-between align-items-center">
    <strong class="title mx-auto text-center w-100 fs-6">
      {{ isPositionEdit || isEventDetailEdit ? ('POPUP.EVENT_EDITION' | translate) : ('POPUP.NEW_EVENT' | translate) }}
    </strong>
    <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
      (click)="onClose()"></button>
  </div>
  <!-- CONTENT -->
  <div class="popup-content">
    <form class="form" [formGroup]="form!" (ngSubmit)="submit()" id="ngForm">
      <!-- fist 2 rows are used in 'create new control point' -->
      @if (!isPositionEdit) {
      <div class="d-flex">
        <div class="row-item-width-100 input-container">
          <label class="input-label ">{{ 'FORM.NAME' | translate }}<span
              class="text-danger">*</span></label>
          <input class="input-field" id="name" placeholder="{{ 'FORM.EVENT_NAME' | translate }}"
            formControlName="eventName" name="eventName" type="text" />

          @if (form?.get('eventName')?.invalid && form?.get('eventName')?.touched) {
          <div class="input-errors">
            @if (form?.get('eventName')?.errors?.['required']) {
            <span>{{ 'ERRORS.NAME_REQUIRED' | translate }}</span>
            } @if (form?.get('eventName')?.errors?.['minlength']) {
            <span>{{ 'ERRORS.NAME_MIN_LENGTH' | translate }}</span>
            } @if (form?.get('eventName')?.errors?.['pattern']) {
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>


      </div>


      <div class="d-flex mt-4">
        <div class="col-6 input-container">
          <div class="row-item-width-100 input-container">
            <label class="input-label " for="eventTypeLabel">{{ 'FORM.TYPE' | translate }}<span
              class="text-danger">*</span></label>
            <ng-select name="eventType" id="id" [items]="eventTypes" bindLabel="eventTypeLabel"
              formControlName="eventType" [addTag]="true" [hideSelected]="false" [multiple]="false"
              [closeOnSelect]="true" notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
              placeholder="{{ 'FORM.EVENT_TYPE' | translate }}">
            </ng-select>
            @if (form?.get('eventType')?.invalid && form?.get('eventType')?.touched) {
            <div class="input-errors">
              @if (form?.get('eventType')?.errors?.['required']) {
              <span>{{ 'ERRORS.TYPE_REQUIRED' | translate }}</span>
              }
            </div>
            }
          </div>
        </div>
        <div class="col-5 input-container" class="col-6 input-container">
          <div class="row-item-width-100 input-container ps-1">
            <label class="input-label " for="selectType">{{ 'FORM.PROJECT' | translate }}<span
              class="text-danger">*</span></label>
            <ng-select name="selectProjet" id="id" [items]="eventprojets" bindLabel="projetLabel"
              formControlName="projetLabel" [addTag]="true" [hideSelected]="false" [multiple]="false"
              [closeOnSelect]="true" notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
              placeholder="{{ 'FORM.PROJECT' | translate }}">
            </ng-select>
            @if (form?.get('projetLabel')?.invalid && form?.get('projetLabel')?.touched) {
            <div class="input-errors">
              @if (form?.get('projetLabel')?.errors?.['required']) {
              <span>{{ 'ERRORS.PROJECT_EVENT_REQUIRED' | translate }}</span>
              }
            </div>
            }
          </div>
        </div>

      </div>

      <div class="d-flex mt-4">
        <div class="col-6 input-container">
          <label class="input-label">{{ 'FORM.START_DATE' | translate }}<span
              class="text-danger">*</span></label>
          <input class="input-field" type="datetime-local" placeholder="{{ 'PLACEHOLDERS.DATE_FORMAT' | translate }}"
            formControlName="startDate" />
          @if (form?.get('startDate')?.invalid && form?.get('startDate')?.touched) {
          <div class="input-errors">
            @if (form?.get('startDate')?.errors?.['required']) {
            <span>{{ 'ERRORS.START_DATE_REQUIRED' | translate }}</span>
            }
            @if (form?.get('startDate')?.errors?.['dateinvalid']) {
            <span>{{ 'ERRORS.INVALID_DATE' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="col-6 input-container ps-1">
          <label class="input-label">{{ 'FORM.END_DATE' | translate }}</label>
          <input type="datetime-local" class="input-field" placeholder="{{ 'PLACEHOLDERS.DATE_FORMAT' | translate }}"
            formControlName="endDate" />
          @if (form?.get('endDate')?.invalid && form?.get('endDate')?.touched) {
          <div class="input-errors">
            @if (form?.get('endDate')?.errors?.['required']) {
            <span>{{ 'ERRORS.END_DATE_REQUIRED' | translate }}</span>
            }
            @if (form?.get('endDate')?.errors?.['dateinvalid']) {
            <span>{{ 'ERRORS.INVALID_DATE' | translate }}</span>
            }
          </div>
          }
        </div>
      </div>
      }

      <!-- ROW 3 -->
      <div class="d-flex mt-4">
        <div class="row-item-width-100 input-container">
          <label class="input-label">{{ 'FORM.EPSG' | translate }}</label>
          <!-- <input class="input-field" id="number" formContro lName="number" name="number" type="text" /> -->
          <ng-select [items]="filteredEpsgCodes" [typeahead]="typeahead$" bindLabel="text" bindValue="id"
            placeholder="{{ 'PLACEHOLDERS.SEARCH_EPSG' | translate }}"
            typeToSearchText="{{ 'PLACEHOLDERS.TYPE_TO_SEARCH' | translate }}" [(ngModel)]="selectedEpsg"
            [ngModelOptions]="{ standalone: true }" [searchable]="true" [compareWith]="compareItems"
            [loading]="loading">
            <!-- Shows loading spinner when searching -->
          </ng-select>
          @if(epsgIsOk === false){
          <div class="input-errors">
            <span>{{ 'ERRORS.INVALID_EPSG' | translate }}</span>
          </div>
          }
        </div>
      </div>

      <!-- ROW 4 -->
      <div class="d-flex mt-4">
        <div class="col-md-4 input-container">
          <label class="input-label">{{ C1 }}<span
              class="text-danger">*</span></label>
          <input class="input-field" id="x" placeholder="x" formControlName="x" name="x" type="text" />
          @if(form?.get('x')?.invalid && form?.get('x')?.touched){
          <div class="input-errors">
            @if(form?.get('x')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="col-md-4 input-container ps-1">
          <label class="input-label">{{ C2 }}<span
              class="text-danger">*</span></label>
          <input class="input-field" id="y" placeholder="y" formControlName="y" name="y" type="text" />
          @if(form?.get('y')?.invalid && form?.get('y')?.touched){
          <div class="input-errors">
            @if(form?.get('y')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="col-md-4 input-container ps-1">
          <label class="input-label">{{ C3 }}</label>
          <input class="input-field" id="z" placeholder="z" formControlName="z" name="z" type="number" />
          @if(form?.get('z')?.invalid && form?.get('z')?.touched){
          <div class="input-errors">
            @if(form?.get('z')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>
      </div>

      @if (!isPositionEdit) {
      <div class="d-flex mt-4">
        <div>
          <b>{{ 'EVENT.HOLES' | translate }}</b>
        </div>

        <div class="divider mt-2"></div>
      </div>
      <div class="card">
        <div class="d-flex">

          <div class="col-6 input-container">
            <label class="input-label">{{ 'EVENT.DIAMETER' | translate }} (mm)</label>
            <input class="input-field" id="diameter" placeholder="diameter" formControlName="diameter" name="diameter"
              type="text" />
            @if(form?.get('diameter')?.invalid && form?.get('diameter')?.touched){
            <div class="input-errors">
              @if(form?.get('diameter')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

          <div class="col-6 input-container ps-1">
            <label class="input-label">{{ 'EVENT.BURDEN' | translate }} (m)</label>
            <input class="input-field" id="burden" placeholder="burden" formControlName="burden" name="burden"
              type="text" />
            @if(form?.get('burden')?.invalid && form?.get('burden')?.touched){
            <div class="input-errors">
              @if(form?.get('burden')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

        </div>

        <div class="d-flex">

          <div class="col-6 input-container">
            <label class="input-label">{{ 'EVENT.SPACING' | translate }} (m)</label>
            <input class="input-field" id="spacing" placeholder="spacing" formControlName="spacing" name="spacing"
              type="text" />
            @if(form?.get('spacing')?.invalid && form?.get('spacing')?.touched){
            <div class="input-errors">
              @if(form?.get('spacing')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

          <div class="col-6 input-container ps-1">
            <label class="input-label">{{ 'EVENT.HOLES' | translate }} (u)</label>
            <input class="input-field" id="holes" placeholder="holes" formControlName="holes" name="holes"
              type="text" />
            @if(form?.get('holes')?.invalid && form?.get('holes')?.touched){
            <div class="input-errors">
              @if(form?.get('holes')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

        </div>
      </div>
      <div class="d-flex mt-4">
        <div>
          <b>{{ 'EVENT.CHARGES' | translate }}</b>
        </div>

        <div class="divider mt-2"></div>
      </div>
      <div class="card">
        <div class="d-flex">

          <div class="col-6 input-container">
            <label class="input-label">{{ 'EVENT.TOTAL' | translate }} (kg)</label>
            <input class="input-field" id="total" placeholder="total" formControlName="total" name="total"
              type="text" />
            @if(form?.get('total')?.invalid && form?.get('total')?.touched){
            <div class="input-errors">
              @if(form?.get('total')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

          <div class="col-6 input-container ps-1">
            <label class="input-label">{{ 'EVENT.DETONATOR' | translate }} (u)</label>
            <input class="input-field" id="detonator" placeholder="detonator" formControlName="detonator"
              name="detonator" type="text" />
            @if(form?.get('detonator')?.invalid && form?.get('detonator')?.touched){
            <div class="input-errors">
              @if(form?.get('detonator')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

        </div>

        <div class="d-flex">

          <div class="col-6 input-container">
            <label class="input-label">{{ 'EVENT.STEMMING' | translate }} (m)</label>
            <input class="input-field" id="stemming" placeholder="stemming" formControlName="stemming" name="stemming"
              type="text" />
            @if(form?.get('stemming')?.invalid && form?.get('stemming')?.touched){
            <div class="input-errors">
              @if(form?.get('stemming')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

          <div class="col-6 input-container ps-1">
            <label class="input-label">MIC (kg)</label>
            <input class="input-field" id="mic" placeholder="mic" formControlName="mic" name="mic" type="text" />
            @if(form?.get('mic')?.invalid && form?.get('mic')?.touched){
            <div class="input-errors">
              @if(form?.get('mic')?.errors?.['pattern']){
              <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
              }
            </div>
            }
          </div>

        </div>
      </div>
      }




    </form>
  </div>

  <!-- 
      FOOTER -->
  <div class="popup-footer m-4">
    <button class="secondary-button popup-secondary-button" (click)="onClose()">{{ 'BUTTONS.CANCEL' | translate }}</button>
    <button class="primary-button popup-primary-button" form="ngForm" type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
  </div>
</div>